import BaseAPI from './baseApi'

const users = new BaseAPI(`/users`)
const user = new BaseAPI(`/users/`)
// 通知・発報履歴一覧
const alertHistory = new BaseAPI(`/alertHistory`)
// 状態確認
const monitoring = new BaseAPI(`/monitoring`)
// 踏切情報
const railroadCrossing = new BaseAPI(`/railroadCrossing`)
// 検知エリア情報
const detectionArea = new BaseAPI(`/detectionArea`)
const reflectDetectionArea = new BaseAPI(`/reflectDetectionArea`)
const areaCheckMonitoring = new BaseAPI(`/areaCheckMonitoring`) // 2021/09/10 検知エリア確認機能追加
// 顧客・運行指令所情報
const operationCommandCenter= new BaseAPI(`/operationCommandCenter`)
// エッジ一覧情報
const edgeDevice = new BaseAPI(`/edgeDevice`)
// カメラ一覧情報
const camera = new BaseAPI(`/camera`)
// 最新画像取得
const latestImage = new BaseAPI(`/latestImage`)
// ファイルダウンロード
const fileDownLoad = new BaseAPI(`/fileDownLoad`)
// 2FA
const setTwoFA = new BaseAPI(`/setTwoFA`)
const activateTwoFA = new BaseAPI(`/activateTwoFA`)
const deactivateTwoFA = new BaseAPI(`/deactivateTwoFA`)

export default {
  users: users,
  user: user,
  alertHistory: alertHistory,
  monitoring: monitoring,
  railroadCrossing: railroadCrossing,
  reflectDetectionArea: reflectDetectionArea,
  detectionArea: detectionArea,
  areaCheckMonitoring: areaCheckMonitoring, // 2021/09/10 検知エリア確認機能追加
  operationCommandCenter: operationCommandCenter,
  edgeDevice: edgeDevice,
  camera: camera,
  latestImage: latestImage,
  fileDownLoad: fileDownLoad,
  setTwoFA: setTwoFA,
  activateTwoFA: activateTwoFA,
  deactivateTwoFA: deactivateTwoFA
}
